import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

axios.defaults.baseURL = 'http://localhost:8003'
axios.defaults.headers.post['Content-Type'] = 'application/json'

createApp(App).use(store).use(router).mount('#app')
